
// => Styling
import styles from './ShopItem.module.css';

// => Icons
import {
    IoDiamond,
} from "react-icons/io5";

// => Data
import shopItems from '../../../content/shopItems.json';

// => React
import { useState } from 'react';


// ============
// Component
// ============
const ShopItem = ({
    data = shopItems[0],
    affordable = false,
    onRequestBuy = (id) => {},
    availability = true,
}) => {

    const [active, setActive] = useState(false)

    const isDisabled = () => {
        if (!affordable) {
            return true
        }
        if (!availability)
            return true
        return false
    }

    const boosterDisclaimer = () => {
        if (data.type === "booster") {
            return(
                <>
                    <span style={{fontSize: '8pt', fontWeight: '200'}}>[Contains <b>{data.boosterCount}</b> random cards]</span>
                    <br/>
                </>
            )
        }
        else return <></>
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container} onMouseEnter={()=>setActive(true)} onMouseLeave={()=>setActive(false)}>
            {}
            <div className={[styles.img, availability ? null : styles.imgUnavailable].join(" ")} src={data.img} style={{backgroundImage: "url("+data.img+")"}} />
            <div className={styles.content}>
                <div style={{flex: 1}}/>
                <div className={[styles.info, active ? styles.infoActive : null].join(" ")}>
                    <span className={styles.name}>{data.name}</span>
                    <span className={styles.price}>
                        <IoDiamond size="10pt"/>{data.cost}
                    </span>
                </div>
                <div className={[styles.options, active ? styles.optionsActive : null].join(" ")}>
                    <span className={styles.desc}>{boosterDisclaimer()}{data.desc}</span>
                    <button disabled={isDisabled()} 
                            className={[styles.buyBtn, availability ? null : styles.buyBtnTextNoStock].join(" ")}
                            onClick={()=>onRequestBuy(data.id)}>
                        {availability ? <>PURCHASE (<IoDiamond size="10pt"/>{data.cost})</>
                        : <>NOT IN STOCK</>}
                    </button>
                </div>
            </div>
        </div>
    );
}


export default ShopItem